import Vue from "vue";
import Buefy from "buefy";
import "@/styles/vendor/buefy/custom.scss";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faEyeSlash, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import NotificationsPlugin from "../../utils/notification";

library.add(faEyeSlash, faEye);
Vue.component("vue-fontawesome", FontAwesomeIcon);

Vue.use(Buefy, {
  defaultIconComponent: "vue-fontawesome",
  defaultIconPack: "fas",
  defaultContainerElement: "#content"
});

Vue.use(NotificationsPlugin);
